export default "__VITE_ASSET__1853522b__"